<template>
    <div>
        <veui-dialog
            v-if="!isAuthorized"
            :open="show"
            ui="auto"
            overlay-class="vip-authorize-modal"
            @cancel="cancel"
        >
            <div slot="title" class="header">
                <div class="title">
                    开通会员可享13大法行宝权益
                </div>
                <div class="subTitle">
                    当前会员限时优惠中，更有额外惊喜等你来，快点击下方按钮，让法行宝专业客服为您介绍权益细则
                </div>
            </div>
            <div slot="foot" class="footer">
                <veui-button
                    ui="l" class="btn"
                    @click="handleClick"
                >
                    授权客服电联，了解更多会员权益
                </veui-button>
            </div>
        </veui-dialog>
        <veui-dialog
            v-if="isAuthorized && show"
            :open="isShow"
            :footless="true"
            :closable="true"
            :outside-closable="true"
            ui="auto"
            overlay-class="authorize-wx-dialog"
            @cancel="handleClick"
        >
            <div class="content">
                <div class="title">已成功完成授权，专人将尽快联系您沟通会员相关权益</div>
                <div class="sub-title">如您有任何问题，也可以用微信扫一扫以下二维码直接联系运营专员</div>
                <div class="qrcode"></div>
            </div>
        </veui-dialog>
    </div>
</template>
<script>
/**
 * @file vip授权引导弹窗
 * @author xingminghua
 */
import {mapState} from 'vuex';
import {Dialog, Button} from 'veui';

export default {
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        authorized: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            passInfo: state => state.lawStore?.userInfoNew?.pass_info || {}
        })
    },
    watch: {
        authorized: {
            immediate: true,
            handler(newVal) {
                this.isAuthorized = newVal;
                this.isShow = newVal;
            }
        }
    },
    data() {
        return {
            isAuthorized: false,
            isShow: false
        };
    },
    methods: {
        cancel() {
            this.$emit('cancel');
        },
        handleClick() {
            // 授权
            if (!this.isAuthorized) {
                this.$http
                    .post('/bp/api/vip/genvip', {
                        name: this.passInfo.pass_name
                    })
                    .then(res => {
                        if (+res?.code === 0) {
                            this.isAuthorized = true;
                            this.isShow = true;
                        }
                        else {
                            this.$normalizeResponseError(res);
                        }
                    });
            }
            // 关闭
            else {
                this.$wywLog.send({
                    serverId: 17078,
                    action: 'click',
                    area: 'authorize-dialog-btn'
                });
                this.cancel('dialog_btn');
            }
        }
    }
};
</script>
<style lang='less' scoped>
.vip-authorize-modal {
    /deep/ .veui-dialog-content {
        width: 420px;
        padding: 0;
        overflow: hidden;
        background-image: linear-gradient(180deg, #facba2 -24.21%, #fff 17.37%);
        position: relative;

        .veui-dialog-content-head {
            background-color: transparent;
            position: relative;
            padding: 30px;

            .veui-dialog-content-head-close {
                position: absolute;
                top: 27px;
                right: 27px;
            }
        }

        .veui-dialog-content-body {
            padding: 2px 20px;
        }

        .veui-dialog-content-foot {
            padding: 0;
        }
    }

    .header {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;

        .icon {
            margin-bottom: 3px;
            width: 120px;
            height: 110px;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .title {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #000;
            font-weight: 500;
            margin-bottom: 24px;
            text-align: center;
        }

        .subTitle {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #000;
            line-height: 22px;
            font-weight: 400;
            text-align: center;
        }
    }

    .footer {
        padding: 0 30px 30px;

        .btn {
            font-family: PingFangSC-Medium;
            font-size: 14px;
            background-color: #fed9b9;
            color: #401611;
            font-weight: 700;
            width: 100%;
            height: 40px;
        }
    }
}

.authorize-wx-dialog {
    /deep/.veui-dialog-content {
        border-radius: 8px;
        width: 845px;
        box-shadow: 0 0 10px 0 #c4c4c480;
        background-color: #fff;
        padding: 23px 30px 30px;

        .veui-dialog-content-head {
            padding: 0;
        }

        .veui-dialog-content-body {
            margin: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0;

            .title {
                font-family: PingFang SC;
                font-weight: 500;
                font-style: Medium;
                font-size: 18px;
                line-height: 18px;
                color: #000311;
                margin-top: 18px;
                text-align: center;
            }

            .sub-title {
                font-family: PingFang SC;
                font-weight: 400;
                font-style: Regular;
                font-size: 14px;
                line-height: 14px;
                color: #666e85;
                margin-top: 12px;
                text-align: center;
            }

            .qrcode {
                width: 264px;
                height: 276px;
                margin: 0 auto 20px;
                background: url("https://lvlin-fe-saas.cdn.bcebos.com/assets/authorize-wx-qrcode-lijing-new.png") no-repeat;
                background-size: 100% 100%;
            }
        }
    }
}
</style>